import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemStrip } from './components/ProblemStrip';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-gold-500 selection:text-navy-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemStrip data-id="element-4" />
        <Benefits data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Pricing data-id="element-7" />
        <FAQ data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}